export const chatWebsocketTopics = {
  send: (id: string) => `/chat/${id}/send`,
  messages: (id: string) => `/chat/${id}/messages`,
  preview: (id: string) => `/chat/${id}/preview`,
}
